import { render, staticRenderFns } from "./JourneyDateRange.vue?vue&type=template&id=bbf35292&scoped=true&"
import script from "./JourneyDateRange.vue?vue&type=script&lang=js&"
export * from "./JourneyDateRange.vue?vue&type=script&lang=js&"
import style0 from "./JourneyDateRange.vue?vue&type=style&index=0&id=bbf35292&lang=scss&scoped=true&"
import style1 from "./JourneyDateRange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf35292",
  null
  
)

export default component.exports